import { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@material-ui/icons";
import constants from "./constants";

const styles = (theme) => ({
  container: {
    maxHeight: "60px", // Initial max height
    overflow: "hidden",
    transition: "max-height 0.3s ease",
    margin: '8 0 4 0'
  },
  expanded: {
    maxHeight: "160px", // Expanded max height
    overflowY: "auto",
  },
  headerContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: 4,
  },
  proLabel: {
    color: theme.iconColor,
    fontSize: theme.textFontSize,
    borderRight: `1px solid ${theme.AppBGColor}`,
    paddingRight: 6,
  },
  customerLabel: {
    color: theme.iconColor,
    fontSize: theme.textFontSize,
    paddingLeft: 6,
  },
  titleValue: {
    fontSize: theme.textFontSize,
    fontWeight: "600",
    color: theme.TextColor,
    paddingLeft: 4,
  },
  expand: {
    marginLeft: "auto",
    color: theme.ToggleIconColor,
    float: "left",
    padding: 0,
    marginBottom: 16,
  },
  showMore: {
    color: theme.palette.primary.main,
    fontWeight: 400,
    fontSize: theme.dispatchCardTextFontSize,
    textTransform: "uppercase",
  }
});

const CustomerList = ({ classes, customerList }) => {
  const [expanded, setExpanded] = useState(false);

  const handleShowMore = () => {
    setExpanded(!expanded);
  };

  return (
    <div>
      <div
        className={`${classes.container} ${expanded ? classes.expanded : ""} customScroll`}
      >
        {customerList.map((customer, index) => (
          <div key={index} className={classes.headerContainer}>
            <div className={classes.proLabel}>
              PRO#
              <span className={classes.titleValue}>{customer.proNumber}</span>
            </div>
            <div className={classes.customerLabel}>
              {customer.type}
              <span className={classes.titleValue}>
                {customer.customerDetail}
              </span>
            </div>
          </div>
        ))}
      </div>
      {customerList.length > constants.CUSTOMER_LIST_COLLAPSED_COUNT && (
        <IconButton className={classes.expand} onClick={handleShowMore}>
          <span className={classes.showMore}>{expanded ? 'Show Less' : 'Show More'}</span>
          {expanded ? (
            <ExpandLessIcon className={classes.expandIcon} />
          ) : (
            <ExpandMoreIcon className={classes.expandIcon} />
          )}
        </IconButton>
      )}
    </div>
  );
};

export default withStyles(styles)(CustomerList);
